/**
 * The failed state for a team page read: one line saying the read failed and
 * a Try again button. It replaces an empty or not found line whenever the
 * read did not answer, so the page never states something false about a real
 * team (ISSUE-1021). Mirrors the league drill-down's failed state in
 * `LeagueDrillDownPane.tsx`.
 */
import { Button } from "@sportsmet/ui";
import type { ReactNode } from "react";

import { TRY_AGAIN_LABEL } from "../scores/leagueSelectorContract";

export type typeTeamReadFailedProps = {
  /** "page" replaces the whole screen body; "panel" sits inside a card or tab panel. */
  layout: "page" | "panel";
  testId: string;
  line: string;
  onRetry: () => void;
};

export const TeamReadFailed = (props: typeTeamReadFailedProps): ReactNode => (
  <div
    data-testid={props.testId}
    className={
      props.layout === "page"
        ? "mx-auto flex max-w-120 flex-col items-center gap-2 py-10 text-center"
        : "flex flex-col items-start gap-2 px-4 py-3"
    }
  >
    <p className="text-body text-error">{props.line}</p>
    <Button variant="secondary" onClick={props.onRetry}>
      {TRY_AGAIN_LABEL}
    </Button>
  </div>
);
